import { render } from "./MainLayout.vue?vue&type=template&id=28c36671&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=28c36671&scoped=true&lang=scss"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c36671"]])

export default __exports__